import React, { Fragment, useState } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    Button,
    Dialog, DialogActions, DialogContent, DialogTitle,
    Typography,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { deleteUserPlayer, userPlayersSelector } from 'reducers/userPlayers';
import { usersSelector } from 'reducers/users';
import { RequestStateHelper } from 'reducers/createRequestReducer';
import ExitIcon from '@material-ui/icons/ExitToApp';
import { push } from 'connected-react-router';
import { fetchPlayerUsers } from '../../reducers/users';
import {LocaleConsumer} from "containers/locale/LocaleProvider";
import { compose } from 'recompose';

const styles = {
    dialogActions: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px',
    },
    removeBtn: {
        fontSize: '0.7rem',
        padding: '0 4px 0 0',
    },
};

function ExitCareCircleButton({
    classes,
    isCurrentUser,
    isDeleting,
    user,
    player,
    exitCareCircle,
    fetchPlayerUsers,
    redirect,
}) {
    const [open, setOpen] = useState(false);
    
    const handleRequestClose = () => {
        if (isDeleting) return;
        setOpen(false);
    };

    const handleAccept = () => {
        const userPlayerId = user.id + '_' + player.id;
        exitCareCircle(userPlayerId).then(() => {
            fetchPlayerUsers(player.id);
            isCurrentUser ? redirect('/') : setOpen(false);
        });
    }

    return (
        <LocaleConsumer>
            {({ getTranslation }) => (
                <span>
                    <Dialog open={open} onClose={handleRequestClose}>
                        <DialogTitle>{isCurrentUser ? getTranslation("player_modal_exit_the_care_circle") : getTranslation("player_modal_remove_from_care_circle")}</DialogTitle>
                        <DialogContent>
                            <Typography variant="body1">
                                {isCurrentUser ? (
                                    <Fragment>
                                        {getTranslation("player_modal_confirm_exit_message")} <br />
                                        {getTranslation("player_modal_confirm_exit_warning_message")} <br />
                                    </Fragment>
                                ) : (
                                    <Fragment>
                                        {getTranslation("player_modal_confirm_remove_message", user.email)}
                                    </Fragment>
                                )}
                            </Typography>
                        </DialogContent>
                        <DialogActions className={classes.dialogActions}>
                            <Button onClick={handleRequestClose} color="primary" disabled={isDeleting}>
                                {getTranslation("cancel")}
                            </Button>
                            <Button onClick={handleAccept} color="primary" disabled={isDeleting}>
                                {isCurrentUser ? getTranslation("player_modal_confirm_exit") : getTranslation("player_modal_confirm_remove")}
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Button onClick={() => setOpen(true)} className={classes.removeBtn}>
                        <ExitIcon /> {isCurrentUser ? getTranslation("exit_care_circle") : getTranslation("remove_from_care_circle")}
                    </Button>
                </span>
            )}
        </LocaleConsumer>
    );
}

export default compose(
    connect(
        (state, ownProps) => ({
            isDeleting: RequestStateHelper.isLoading(userPlayersSelector.getUserPlayerDeleteState(state)),
            isCurrentUser: usersSelector.getCurrentUser(state).id === ownProps.user.id,
        }),
        (dispatch) => ({
            exitCareCircle: (userPlayerId) => dispatch(deleteUserPlayer(userPlayerId)),
            redirect: (location) => dispatch(push(location)),
            fetchPlayerUsers: (playerId) => dispatch(fetchPlayerUsers(playerId)),
        }),
    ),
    withStyles(styles)
)(ExitCareCircleButton);